module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unauth_h":"Unauthorized","not_yet_open":"Please log in/sign up first."},"de":{"unauth_h":"Login","not_yet_open":"Bitte zuerst anmelden/registrieren."}}')
  delete Component.options._Ctor
}
